import React from 'react';
import TextComponent from '../TextComponent';

const WidthText = (props) => {
  const name = 'pallet_width';
  const {
    onChangeParameter, onChange, label, parameters, required, tooltip, groupName, children,
  } = props;
  const defaultChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange || defaultChange}
      tooltip={tooltip}
      groupName={groupName}>
      {children}
    </TextComponent>
  );
};

WidthText.defaultProps = {
  required: true,
  label: 'Pallet Width ',
};

export default WidthText;
